export const ArrowPrevIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg width="20" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M7.5 13L1.5 7L7.5 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
